import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, label, title, lead, dark = false, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal delay={0.08}>
      <h2 className={`mt-5 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${dark ? "text-white" : "text-[#1A1A1A]"}`}>
        {title}
      </h2>
    </Reveal>
    {lead ? (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-white/70" : "text-slate-600"}`}>{lead}</p>
      </Reveal>
    ) : null}
  </div>
);
